import React from "react";
import { connect } from "react-redux";
import { TStateMapper } from "tsi-common-react/src/apps/reducers.interfaces";
import { formatDistance } from "tsi-common-react/src/apps/retail/helpers";
import { IRetailStoreWithDistance } from "tsi-common-react/src/models/location.interfaces";
import { t } from "ttag";

import { nearestFlagshipStoreSelector } from "../selectors";

interface IOwnProps {}

interface IReduxProps {
    store: IRetailStoreWithDistance | null;
}

type IProps = IOwnProps & IReduxProps;

interface IState {}

// TODO(ssr, VERY_LOW 2 out of 10): Migrate this component from class-style to functional-style. Rated LOE as 2/10 due to simple render-only logic with distance formatting, Redux connection, and no state or lifecycle methods.
class DistanceToFlagshipStoreContainer extends React.Component<IProps, IState> {
    render() {
        let text: string = t`See Closest Location`;
        if (this.props.store && this.props.store.distance) {
            const formattedDist = formatDistance(this.props.store.distance);
            text = t`${formattedDist} miles away`;
        }
        return <>{text}</>;
    }
}

const mapStateToProps: TStateMapper<"retail", IReduxProps, IOwnProps> = (
    state,
    ownProps,
) => {
    return {
        ...ownProps,
        store: nearestFlagshipStoreSelector(state),
    };
};

export const DistanceToFlagshipStore = connect(mapStateToProps)(
    DistanceToFlagshipStoreContainer,
);
